// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1s09y","top":"styles_top__1olt3"};